import * as React from 'react';

import { useTranslation } from 'next-i18next';

import OtherBlogs from '../../components/blog/OtherBlogs';
import ClientsContactPanel from '../../components/common/ContactPanel/ClientsContactPanel';
import Layout from '../../components/common/Layout';
import Strip from '../../components/common/Strip';
import {
  CfoFxReport,
  ControlFx,
  OneStopExecution,
  QuoteBanner,
  WhyChooseUs,
} from '../../components/corporateTreasurers';
import { MobileContextProvider } from '../../helpers';
import { useItems } from '../../hooks';
import { CORP_TREASURERS_RELATED_ARTICLES } from '../../queries';
import { withTranslation } from '../../translation';
import { IContact, IPageWithOtherBlogPosts } from '../../types';

const CorporateTreasurersPage = ({ pageData }: IPageWithOtherBlogPosts) => {
  const { t } = useTranslation('clients');
  const { SEO, otherBlogs } = t('corporate-treasurers', {
    returnObjects: true,
  }) as any;
  const contactPanelInfo: IContact = t('contactPanelInfo', {
    returnObjects: true,
  }) as any;

  const {
    articles: { otherBlogs: otherBlogsData },
  } = pageData;

  return (
    <MobileContextProvider>
      <Layout SEO={SEO}>
        <OneStopExecution />
        <QuoteBanner />
        <WhyChooseUs />
        <ControlFx />
        <CfoFxReport />
        <OtherBlogs title={otherBlogs.title} blogs={otherBlogsData} />
        <Strip variant="dark_grey" style={{ padding: 0 }}>
          <ClientsContactPanel data={contactPanelInfo} customCss={true} />
        </Strip>
      </Layout>
    </MobileContextProvider>
  );
};

export default CorporateTreasurersPage;

export const getStaticProps = withTranslation(async (context) => {
  const articles = await useItems(CORP_TREASURERS_RELATED_ARTICLES);

  return {
    props: {
      pageData: {
        articles: articles.items,
      },
    },
  };
});
